import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiNews } from '@app/packages/api/v2/types/entities'
import type { NewsMeta } from '@app/packages/api/v2/types/params'
import { v2Path } from '@app/packages/api/v2/utils'

export const getNews = (query: { page?: number; per_page?: number; before?: number }) =>
  createApiAction('getNews', dispatch => dispatch<{ meta: NewsMeta; data: ApiNews[] }>({ method: 'GET', endpoint: v2Path('/api/v2/news', query) }))

export const getNewsById = (id: string) =>
  createApiAction('getNewsById', dispatch => dispatch<{ data: ApiNews }>({ method: 'GET', endpoint: urlEscaped`/api/v2/news/${id}` }))

export const postNewsRead = () => createApiAction('postNewsRead', dispatch => dispatch<unknown>({ method: 'POST', endpoint: '/api/v2/news/read' }))
